module.exports = __webpack_public_path__ + "img/pay.40590b73.png";